import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { IngestDefinitionService } from "@services/ingest/ingestDefinitionService.ts";
import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";

interface CustomerDefinition {
  id: number;
  name: string;
}

export default function UploadsListPage() {
  useDocumentTitle("Uploads");
  const [definitions, setDefinitions] = useState<CustomerDefinition[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    new IngestDefinitionService().fetchDefinitions().then((defs: any[]) => {
      // Skip this picker entirely when there's only one option — the typical
      // customer case. They land directly on the upload page.
      if (defs.length === 1) {
        navigate(`/uploads/${defs[0].id}`, { replace: true });
        return;
      }
      setDefinitions(defs.map((d) => ({ id: d.id, name: d.name })));
    });
  }, [navigate]);

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" fontWeight={600}>Uploads</Typography>
        <Typography sx={{ color: "#8c9097", fontSize: 13, mt: 0.5 }}>
          Choose a data file to upload.
        </Typography>
      </Box>

      <TableContainer sx={{ bgcolor: "#fff", borderRadius: 2, border: "1px solid #f3f3f3" }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: "#f9fafb" }}>
              <TableCell sx={{ fontWeight: 600, color: "#8c9097", fontSize: 12, textTransform: "uppercase", letterSpacing: 0.3 }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 600, color: "#8c9097", fontSize: 12, textTransform: "uppercase", letterSpacing: 0.3 }} align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {definitions.map((def) => (
              <TableRow
                key={def.id}
                hover
                onClick={() => navigate(`/uploads/${def.id}`)}
                sx={{ "&:last-child td": { borderBottom: 0 }, cursor: "pointer" }}
              >
                <TableCell sx={{ fontWeight: 500 }}>{def.name}</TableCell>
                <TableCell align="right">
                  <ChevronRightIcon sx={{ fontSize: 18, color: "#845adf" }} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {definitions.length === 0 && (
          <Box sx={{ p: 4, textAlign: "center", color: "#8c9097" }}>
            <Typography>No upload types available. Please contact your administrator.</Typography>
          </Box>
        )}
      </TableContainer>
    </Box>
  );
}
